import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import z from 'zod'
import { AppLoader } from '~/components/loader'
import { useTRPC } from '~/services/trpc'

const searchParams = z.object({
  externalId: z.string().or(z.number()).transform(String),
})

export const Route = createFileRoute('/_authenticated/$alias/_app/interaction/lookup')({
  component: RouteComponent,
  validateSearch: searchParams,
})

function RouteComponent() {
  const trpc = useTRPC()
  const { externalId } = Route.useSearch()
  const navigate = useNavigate({ from: '/$alias' })
  const { data, error } = useQuery(
    trpc.contactLogs.fromExternalId.queryOptions(externalId),
  )

  useEffect(() => {
    if (data?.id) {
      navigate({
        to: `/$alias/interaction/$contactLogId`,
        params: {
          contactLogId: data.id,
        },
        replace: true,
      })
    }
  }, [data, navigate])

  if (error) {
    return <div>not found</div>
  }

  return <AppLoader />
}
